/**
 * Hrefs into the AVA app's quote pages, for callers under `lib/routes` (which does not import
 * feature constants). Fetch v2 re-exports `avaAddQuotePath`; the other call sites that build the
 * same strings inline are left as-is.
 */

/** The AVA review queue: inactive AI-extracted quotes across every event. */
export const AVA_REVIEW_QUOTES_PATH = "/ava/quotes/review";

/**
 * The quote calculator for one venue on one event, the page every "Add quote" and "Open Quote
 * Calculator" entry point opens.
 *
 * @param eventId - The event id.
 * @param venueStaticId - The venue's static id.
 * @returns `/ava/quotes/add/<eventId>/<venueStaticId>`.
 */
export function avaAddQuotePath(eventId: number, venueStaticId: number): string {
  return `/ava/quotes/add/${eventId}/${venueStaticId}`;
}
